export const DEFAULT_USER_LORA_STRENGTH = 0.9;
export const DEFAULT_LORA_STRENGTH = 1;
export const DEFAULT_FLUXGUIDANCE_GUIDANCE = 3.5;
export const DEFAULT_KSAMPLER_STEPS = 25;
export const DEFAULT_KSAMPLER_CFG = 1;
export const DEFAULT_LORA_NAME = "flux-RealismLora.safetensors";
